const ARGOID_SETTINGS = {
    appId: "HERBSPROINDIA",
    appSource: "HERBSPROINDIA_WEB",
    registeredUserIdPrefix: "gid://shopify/Customer/",
    productIdPrefix: "gid://shopify/Product/"
};

let deviceWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
const uniqueCustomerId = getUniqueCustomerId();

// Get unique customer id
function getUniqueCustomerId() {
    let uniqueCustomerId = "";
    try {
        // Getting GA cookie
        let name = "_ga" + "=";
        let ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                uniqueCustomerId = c.substring(name.length, c.length);
            }
        }
    } catch (error) {
        let logMessage = "unable to get Shopify Analytics uniqToken";
        log(["ERROR", logMessage, error]);
    }

    return uniqueCustomerId;
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
}

function sendEvent(eventType, eventAttributes, settings) {
    let url = "https://herbsproindia.ingestion.prod.saas.argoid.com/web/events";

    const headers = {
        'Authorization': 'Basic cGxvYmFsOmduQ05MbXJCV2w=',
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    };

    var optimizeExperimentVariantId = getCookie('_gaexp');

    var optimizeVariant = null;

    // optimizeExperimentVariantId sample value GAX1.2.7G1YKFNFTaSXvtSomDKP8A.19048.0
    // last value respresents variant
    if (optimizeExperimentVariantId) {
        var optimizeVariantInt = optimizeExperimentVariantId.split(".").pop();
        optimizeVariant = optimizeVariantInt == 0 ? "ORIGINAL" : "ARGOID";
    }

    let sessionId = localStorage.getItem("argoidSessionId");

    let event = {
        "sessionId": sessionId,
        "userIds": {
            "anonymousId": uniqueCustomerId,
            "registeredUserId": ARGOID_SETTINGS.registeredUserIdPrefix + settings.customerId,
        },
        "appId": ARGOID_SETTINGS.appId,
        "appSource": ARGOID_SETTINGS.appSource,
        "eventTimestamp": Date.now(),
        "eventType": "API_STATUS",
        "eventAttributes": {
            "name": eventAttributes.source,
            "status": eventType,
            "code": eventAttributes.statusCode,
            "description": eventAttributes.error ? eventAttributes.error : ""
        },
        "deviceAttributes": {
            "deviceTimeZone": Intl.DateTimeFormat().resolvedOptions().timeZone,
            "deviceOsName": navigator.appVersion.match(/\((.*?)\;/)[1],
            "OsVersion": navigator.appVersion,
            "browser": navigator.userAgent.match(/(?:^|(?:[.!?]\s))(\w+)/)[0],
            "devicePixelRatio": window.devicePixelRatio,
            "language": navigator.language,
            "deviceHeight": screen.height,
            "deviceId": "1355435835494"
        },
        "clientAttributes": {
            "appVersion": "1.0.0",
            "sdkVersion": "1.0.0",
            "themeId": settings.themeId,
            "themeRole": settings.themeRole,
            "optimizeExperimentVariantId": optimizeExperimentVariantId,
            "optimizeVariant": optimizeVariant,
        }
    };

    fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(event),
    });
}

// SCHEMA GENERATION
function getProductMarkupForArgoidProduct(argoidSchemaProduct, shopName) {
    const markupProduct = {
      "@context": "http://schema.org",
      "@type": "Product",
      "brand": {
        "@type": "Brand",
        "name": argoidSchemaProduct.vendor || shopName
      },
      "@id": argoidSchemaProduct.url,
      "@url": argoidSchemaProduct.url,
      "name": argoidSchemaProduct.title,
      "image": argoidSchemaProduct.featuredImage.src,
      "offers": {
        "@type": "Offer",
        "url": argoidSchemaProduct.url,
        "image": argoidSchemaProduct.featuredImage.src,
        "price": argoidSchemaProduct.price,
        "priceCurrency": "USD",
        "availability": argoidSchemaProduct.avaialble ? "InStock" : "OutOfStock"
      }
    }
  
    return markupProduct;
}
  
function getProductMarkupForShopifyProduct(shopifySchemaProduct, shopName) {
    //  + "?argoid"
    const herbsProductUrlPrefix = "https://www.herbspro.com/products/";
    const productUrl = herbsProductUrlPrefix + shopifySchemaProduct?.handle;
  
    const markupProduct = {
      "@context": "http://schema.org",
      "@type": "Product",
      "brand": {
        "@type": "Brand",
        "name": shopifySchemaProduct.vendor || shopName
      },
      "@id": productUrl,
      "description": shopifySchemaProduct.description,
      "@url": productUrl,
      "name": shopifySchemaProduct.title,
      "image": "https:" + shopifySchemaProduct.featured_image,
      "offers": {
        "@type": "Offer",
        "url": productUrl,
        "image": "https:" + shopifySchemaProduct.featured_image,
        "price": shopifySchemaProduct.price,
        "priceCurrency": "USD",
        "availability": shopifySchemaProduct.avaialble ? "InStock" : "OutOfStock"
      }
    }
  
    return markupProduct;
}
  
async function addSchemaMarkupForArgoidSections(settings, argoidRecoProducts) {
    let argoidSectionTagId = settings.sectionId;
    let sectionMarkupType = settings.sectionMarkupType;
    if (sectionMarkupType) {
      let currentPageShopifyProduct = settings.product;
      let productSchemaMarkup = getProductMarkupForShopifyProduct(
        currentPageShopifyProduct, settings.shopName
      );
  
      if (Array.isArray(argoidRecoProducts)) {
        productSchemaMarkup[sectionMarkupType] = argoidRecoProducts.map(
          (arProduct) => getProductMarkupForArgoidProduct(arProduct, settings.shopName)
        );
      }
      // inserting schema markup to the DOM
      let argoidSection = document.getElementById(argoidSectionTagId);
      if (argoidSection) {
        const script = document.createElement("script");
        script.setAttribute("type", "application/ld+json");
        script.textContent = JSON.stringify({...productSchemaMarkup});
        argoidSection.prepend(script);
      }
    }
}


function getUserLocation() {
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, null);
    });
}

async function fetchWithTimeout(url, options, settings) {
    const { timeout = 10000, body = "" } = options;

    const controller = new AbortController();
    const id = setTimeout(() => {
        let event = new CustomEvent(
            "argoid:api:timeout", {
            detail: {
                source: settings.recommendationType,
                error: "Timed out in " + timeout + "ms",
                statusCode: 408,
                settings: settings
            }
        }
        );
        document.body.dispatchEvent(event);

        controller.abort();
    }, timeout);

    const response = await fetch(url, {
        ...options,
        signal: controller.signal
    });
    clearTimeout(id);

    return response;
}

function status(response) {
    if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response);
    } else {
        const err = {
            "statusCode": response.status,
            "message": response.statusText
        }
        return Promise.reject(err);
    }
}

// function to extract the json response
function json(response) {
    return response.json();
}

// function to transform prices into comma separated numbers
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


function processProductsData(data, shopName) {
    let products = data.recommendations || [];

    if (products.length == 0) {
        return Promise.reject(new Error("Product list is empty"));
    }

    let processedProducts = products.map((product) => {
        let processedProduct = {};

        processedProduct.originalId = product.id.match(/(\d+)/)[0];

        processedProduct.id = product.id;
        processedProduct.title = product.title;
        processedProduct.url = product.onlineStoreUrl;
        processedProduct.avaialble = true;

        if (!product.price.currentPrice && product.price.currentPrice !== 0) {
            product.price.currentPrice = product.price.actualPrice;
        }

        if (!product.price.actualPrice && product.price.actualPrice !== 0) {
            product.price.actualPrice = product.price.currentPrice;
        }

        processedProduct.price = numberWithCommas(parseFloat(product.price.currentPrice).toFixed(2));
        processedProduct.compareAtPrice = numberWithCommas(parseFloat(product.price.actualPrice).toFixed(2));

        if (parseFloat(product.price.actualPrice) === 0) {
            processedProduct.discountPercentage = 0;
        } else {
            processedProduct.discountPercentage = (((parseFloat(product.price.actualPrice)) - (parseFloat(product.price.currentPrice))) / (parseFloat(product.price.actualPrice))) * 100;
            processedProduct.discountPercentage = (Math.round(processedProduct.discountPercentage, 0)).toString();
        }

        processedProduct.hasDiscount = false;
        if (processedProduct.discountPercentage > 0) {
            processedProduct.hasDiscount = true;
        }

        if (!product.featuredImage) {
            let defaultImage = "";
            if (product.images.length > 0) {
              defaultImage = product.images[0];
            } else {
              defaultImage = "https://cdn.shopify.com/s/files/1/0083/7032/3541/files/image-coming-soon.jpg?v=1625818672";
            }
            product.featuredImage = defaultImage;
        }

        processedProduct.featuredImage = {
            src: product.featuredImage,
            alt: product.title,
            aspectRatio: 0.75,
        }

        if (product.images?.length > 1) {
            processedProduct.secondaryImage = {
                src: product.images[1],
                alt: product.title,
                aspectRatio: 0.75,
            }
        }

        processedProduct.vendor = product.attributes?.brand;
        if (!product.attributes || !product.attributes.brand) {
            processedProduct.vendor = shopName;
        }

        processedProduct.variants = [{ id: product.defaultVariant.match(/(\d+)/)[0] }];
        // processedProduct.variants = [{id: processedProduct.originalId}];

        processedProduct.avaialble = (product.status === "AVAILABLE");

        return processedProduct;
    });

    return Promise.resolve(processedProducts);
}

// 

function setSectionClass(settings) {
    let recommendationsPerRowNumber = settings.recommendationsPerRowDesktop;
    if (deviceWidth <= 425) {
        recommendationsPerRowNumber = settings.recommendationsPerRowMobile;
    } else if (deviceWidth <= 768) {
        recommendationsPerRowNumber = settings.recommendationsPerRowTablet;
    }

    let className = ``;
    if (settings.sectionType === "grid") {
        className += `argoid-grid argoid-grid--columns-${recommendationsPerRowNumber}`;
    } else if (settings.sectionType === "carousel") {
        className += `argoid-carousel ${settings.sectionId}-carousel`;
    }

    return className;
}

function addSecondaryImage(product, settings) {
    let secondaryImageTemplate = ``;
    if (product.secondaryImage && settings.showSecondaryImage) {
        secondaryImageTemplate += `
        <img src = "${product.secondaryImage.src}" alt="${product.secondaryImage.alt}" class="motion-reduce" loading="lazy">
      `;
    }

    return secondaryImageTemplate;
}

function addCardBadges(product, settings) {
    let badgeTemplate = ``;

    if (settings.showSoldOutBadge && !product.avaialble) {
        badgeTemplate += `
        <div class="argoid-card__badge ${settings.badgePosition} sold-out-badge">
          <strong class="badge__text">${settings.soldOutBadgeText}</strong>
        </div>
      `;
    } else if (product.hasDiscount && product.avaialble && settings.showSaleBadge) {
        let saleBadgeText = settings.saleBadgeText.replace('{X}', product.discountPercentage);

        badgeTemplate += `
        <div class="argoid-card__badge ${settings.badgePosition} sale-badge">
          <strong class="badge__text">${saleBadgeText}</strong>
        </div>
      `;
    }

    return badgeTemplate;
}

function addVendor(product, settings) {
    let vendorTemplate = ``;

    if (settings.showVendor) {
        vendorTemplate += `
        <div class="product-brand">
            <a href="/collections/vendors?q=${encodeURI(product.vendor)}">${product.vendor}</a>
        </div>
      `;
    }

    return vendorTemplate;
}

function addPrice(product, settings) {
    let priceTemplate = ``;

    if (product.hasDiscount) {
        priceTemplate = `
        <div class="price price-sale">
          <span class="old-price">
            <span class="money baccur-money">${settings.shopCurrencySymbol} ${product.compareAtPrice}</span>
          </span>
          <span class="special-price">
            <span class="money baccur-money">${settings.shopCurrencySymbol} ${product.price}</span>
          </span>
        </div>
      `;
    } else {
        priceTemplate = `
        <div class="price price-regular">
          <span class="money baccur-money">${settings.shopCurrencySymbol} ${product.price}</span>
        </div>
      `;
    }

    return priceTemplate;
}

function addWishlistButton(product, settings) {
    let addWishlistButtonTemplate = ``;

    // if (!settings.showWishlistButton) return '';

    addWishlistButtonTemplate = `
        <a data-no-instant data-id=${product.originalId} class="wishlistadd argoid-wishlist-button" rel="nofollow">
            <span class="argoid-wishlist-button-text tt_txt">Add to wishlist</span>
            <i class="facl facl-heart-o"></i>
        </a>
    `;
    
    return addWishlistButtonTemplate;
}

function addAddToCart(product, settings) {
    let addToCartTemplate = ``;

    if (!settings.showAddToCartButton) return '';

    // let disabledTemplate = ``;

    addToCartTemplate = `
    <a class="argoid-add-to-cart-button js_addtc" href="" data-id="${product.variants[0].id}" rel="nofollow">
        <span class="argoid-add-to-cart-text">${product.avaialble ? 'Add to cart' : 'Read more'}</span>
        <i class="iccl iccl-${product.avaialble ? 'cart' : 'info'}"></i>
        <span>${product.avaialble ? 'Add to cart' : 'Read more'}</span>
    </a>
    `;

    // if (!product.avaialble) {
    //     disabledTemplate = `disabled="disabled"`
    // }

    // addToCartTemplate = `
    //   <div class="abs-bottom-mb">
    //     <div class="action">
    //       <form action="/cart/add" method="post" class="variants" id="-${product.originalId}" data-id="product-actions-${product.originalId}" enctype="multipart/form-data">
    //         <input type="hidden" name="id" value="${product.variants[0].id}" /> 
    //         <button data-btn-addToCart class="btn add-to-cart-btn" type="submit" data-form-id="#-${product.originalId}" ${disabledTemplate}>
    //           ${product.avaialble ? 'ADD TO CART' : 'UNAVAILABLE'}
    //         </button>
    //       </form>
    //     </div>
    //   </div>
    // `;

    return addToCartTemplate;
}


function createCard(product, settings) {
    // Setting image ratio
    let ratio = 1;

    if (product.featuredImage && settings.aspectRatio === 'portrait') {
        ratio = 0.8;
    } else if (product.featuredImage && settings.aspectRatio === 'adapt') {
        ratio = product.featuredImage.aspectRatio;
    }

    if (!ratio) {
        ratio = 1;
    }

    let cardTemplate = `
      <div class="card-wrapper underline-links-hover">
        <div class="argoid-card">
  
          <div class="argoid-card__top">
  
            <div class="argoid-card__media">
                <div class="argoid-wishlist-button-container">
                    ${addWishlistButton(product, settings)}
                </div>

                <div class="media media--transparent media--hover-effect">
                    <a href="${product.url}" class="product-grid-image" data-collections-related="/collections/?view=related">
                    <img data-srcset="${product.featuredImage.src}" 
                        src = "${product.featuredImage.src}" 
                        alt="${product.featuredImage.alt}" 
                        class="motion-reduce"
                        style="aspect-ratio: ${ratio}"
                    ></img>
                    </a>
                </div>
                <div class="hover_button argoid-add-to-cart-button-container">
                    ${addAddToCart(product, settings)}
                </div>
            </div>
  
            <div class="argoid-card__content">
              <div class="argoid-card__information">
                <h3 class="argoid-card__heading">
                  <a href="${product.url}" class="full-unstyled-link">${product.title}</a>
                </h3>
              </div>
              ${addCardBadges(product, settings)}
            </div>
  
          </div>
  
          <div class="argoid-card__bottom">
            ${addVendor(product, settings)}
            <h3 class="product-title">
                <a href="${product.url}">${product.title}</a>
            </h3>

            <div class="price-box">
              ${addPrice(product, settings)}
            </div>

          </div>
  
        </div>
      </div>
    `;

    return cardTemplate;

}

function renderGridItems(products, settings) {
    let numberOfProductsToShow = (deviceWidth > 425 && deviceWidth <= 768) ? 3 : 4;

    let gridTemplate = ``;
    let productsCount = 0;
    let hiddenClass = '';
    for (let product of products) {
        productsCount++;
        if (settings.showLoadMoreButton && productsCount > numberOfProductsToShow) {
            hiddenClass = 'hidden';
        }

        gridTemplate += `
        <div class="argoid-grid__item ${hiddenClass}">
          ${createCard(product, settings)}
        </div>
      `;
    }

    return gridTemplate;
}

function renderCarouselItems(products, settings) {
    let carouselTemplate = ``;

    for (let product of products) {
        carouselTemplate += `
        <div class="argoid-carousel-item product-item" data-id="${product.originalId}" data-product-id="product-${product.originalId}">
          ${createCard(product, settings)}
        </div>
      `;
    }

    return carouselTemplate;
}

function renderHtmlContent(settings, products) {
    const wrapperClass = setSectionClass(settings);
    let titleTemplate = `
      <h3 class="argoid-recommendations__title section-title title_2">
        <span>${settings.title}</span>
      </h3>
    `;

    if (settings.product) {
        titleTemplate = `
        <h3 class="argoid-recommendations__title section-title">
          <span>${settings.title}</span>
        </h3>
      `;
    }

    let subtitleTemplate = `<span class="section-subtitle sub-title">${settings.subtitle}</span>`;

    let htmlTemplate = `
    <div class="argoid-recommendations__title-container widget-title">
      ${titleTemplate}
      ${settings.showSubtitle ? subtitleTemplate : ''}
    </div>
      <div class="${wrapperClass}" style="display: flex; flex-wrap: nowrap;">
        ${renderCarouselItems(products, settings)}
      </div>
    `;

    // ${renderLoadMoreButton(settings)}

    const argoidDiv = document.getElementById(settings.sectionId);
    argoidDiv.insertAdjacentHTML("beforeend", htmlTemplate);

    deviceWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;

    let recommendationsPerRowNumber = settings.recommendationsPerRowLargeScreen;
    if (deviceWidth <= 320) {
        recommendationsPerRowNumber = settings.recommendationsPerRowMobileSmall;
    } else if (deviceWidth <= 425) {
        recommendationsPerRowNumber = settings.recommendationsPerRowMobile;
    } else if (deviceWidth <= 767) {
        recommendationsPerRowNumber = settings.recommendationsPerRowTablet;
    } else if (deviceWidth <= 1024) {
        recommendationsPerRowNumber = settings.recommendationsPerRowDesktop;
    }

    if (settings.product) {
        jQuery_3_5_1(`.${settings.sectionId}-carousel`).slick({
            infinite: false,
            slidesToShow: recommendationsPerRowNumber,
            slidesToScroll: recommendationsPerRowNumber,
            adaptiveHeight: true,
            prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-disabled="false" style="display: block;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg></button>',
            nextArrow: '<button type="button" class="slick-next slick-arrow" style="display: block;" aria-disabled="false"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg></button>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        dots: true,
                        arrows: true,
                        slidesToShow: recommendationsPerRowNumber,
                        slidesToScroll: recommendationsPerRowNumber
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        dots: true,
                        arrows: true,
                        slidesToShow: recommendationsPerRowNumber,
                        slidesToScroll: recommendationsPerRowNumber
                    }
                },
                {
                    breakpoint: 425,
                    settings: {
                        dots: true,
                        arrows: true,
                        prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-disabled="false" style="display: block;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg></button>',
                        nextArrow: '<button type="button" class="slick-next slick-arrow" style="display: block;" aria-disabled="false"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg></button>',
                        slidesToShow: recommendationsPerRowNumber,
                        slidesToScroll: recommendationsPerRowNumber
                    }
                },
                {
                    breakpoint: 320,
                    settings: {
                        dots: true,
                        arrows: true,
                        prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-disabled="false" style="display: block;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg></button>',
                        nextArrow: '<button type="button" class="slick-next slick-arrow" style="display: block;" aria-disabled="false"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg></button>',
                        slidesToShow: recommendationsPerRowNumber,
                        slidesToScroll: recommendationsPerRowNumber
                    }
                }
            ]
        });
    } else {
        jQuery_3_5_1(`.${settings.sectionId}-carousel`).slick({
            infinite: false,
            slidesToShow: recommendationsPerRowNumber,
            slidesToScroll: recommendationsPerRowNumber,
            adaptiveHeight: true,
            prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-disabled="false" style="display: block;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg></button>',
            nextArrow: '<button type="button" class="slick-next slick-arrow" style="display: block;" aria-disabled="false"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg></button>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        dots: true,
                        arrows: false,
                        slidesToShow: recommendationsPerRowNumber,
                        slidesToScroll: recommendationsPerRowNumber
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        dots: true,
                        arrows: false,
                        slidesToShow: recommendationsPerRowNumber,
                        slidesToScroll: recommendationsPerRowNumber
                    }
                },
                {
                    breakpoint: 425,
                    settings: {
                        dots: true,
                        arrows: false,
                        slidesToShow: recommendationsPerRowNumber,
                        slidesToScroll: recommendationsPerRowNumber
                    }
                },
                {
                    breakpoint: 320,
                    settings: {
                        dots: true,
                        arrows: false,
                        slidesToShow: recommendationsPerRowNumber,
                        slidesToScroll: recommendationsPerRowNumber
                    }
                }
            ]
        });
    }

}

async function renderRecommendations(settings) {


    settings.shopCurrencySymbol = settings.shopMoneyFormat.split(" ")[0];

    // const apiUrl = `https://a5a83646-f22c-494f-a10c-18f6f125b6d1.mock.pstmn.io/recos`;

    // const apiUrl = `https://600e24e8-a66e-4d58-b503-70895aa82b8f.mock.pstmn.io/v2/you-may-also-like`;

    const apiUrl = `https://prod.herbsproindia.saas.argoid.com/herbsproindia/v2/recommendations/${settings.recommendationType}`;

    const requestHeaders = {
        'Authorization': 'Basic aGVyYnNwcm9pbmRpYTpsa2lCajVoU3Vy',
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }

    let registeredUserId = null;

    if (settings.customerId) {
        registeredUserId = `gid://shopify/Customer/${settings.customerId}`;
    }

    let userLocation;
    try {
        userLocation = await getUserLocation();
    } catch (err) {
        console.log("Location disabled");
    }

    let location = {};

    if (userLocation?.coords) {
        location = {
            lat: userLocation.coords.latitude,
            lng: userLocation.coords.longitude
        }
    }

    if (Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone) {
        location = {
            ...location,
            deviceTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }
    }

    let requestBody = {
        appId: ARGOID_SETTINGS.appId,
        appSource: ARGOID_SETTINGS.appSource,
        includeOutOfStock: settings.includeOutOfStock,
        numberOfRecommendations: settings.totalRecommendations,
        userIds: {
            anonymousId: uniqueCustomerId,
            registeredUserId: registeredUserId
        },
        location: location
    }

    if (settings.product) {
        requestBody = {
            ...requestBody,
            entityIds: {
                productId: `gid://shopify/Product/${settings.product.id}`
            }
        }
    }

    const requestOptions = {
        method: "POST",
        headers: requestHeaders,
        body: JSON.stringify(requestBody)
    };

    let response = await fetchWithTimeout(apiUrl, requestOptions, settings);
    // let response = await fetch(apiUrl);
    const statusCode = response.status;
    let jsonResponse = await response.json();
    let products = [];

    try {
        products = await processProductsData(jsonResponse, settings.shopName);
    } catch (err) {
        console.log(err);
          sendEvent("FAILED", { source: settings.recommendationType, error: err.message, statusCode: statusCode}, settings);
        return;
    }

    sendEvent("SUCCESS", { source: settings.recommendationType, statusCode: statusCode}, settings);

    let recommendationsPerRowNumber = settings.recommendationsPerRowLargeScreen;
    if (deviceWidth <= 369) {
        recommendationsPerRowNumber = settings.recommendationsPerRowMobileSmall;
    } else if (deviceWidth <= 425) {
        recommendationsPerRowNumber = settings.recommendationsPerRowMobile;
    } else if (deviceWidth <= 992) {
        recommendationsPerRowNumber = settings.recommendationsPerRowTablet;
    } else if (deviceWidth <= 1200) {
        recommendationsPerRowNumber = settings.recommendationsPerRowDesktop;
    }

    if (products.length < recommendationsPerRowNumber) return;

    renderHtmlContent(settings, products);

    addSchemaMarkupForArgoidSections(settings, products);
}

// Event listeners and handlers
function argoidAPIFailedHandler(e) {
    sendEvent("API_TIMEOUT", e.detail, e.detail.settings);
}


document.addEventListener("argoid:api:timeout", argoidAPIFailedHandler, false);